import { openDB } from "idb";
let dbHandler;
export async function openIDBWithLock() {
    if (dbHandler) {
        return dbHandler;
    }
    if (!navigator.locks) {
        return await openIDB();
    }
    await navigator.locks.request("open_db", async (lock) => {
        dbHandler = await openIDB();
    });
    return dbHandler;
}
async function openIDB() {
    return await openDB("keyval-store", 2, {
        async upgrade(db, oldVersion, newVersion, transaction) {
            db.createObjectStore("form");
            db.createObjectStore("sync-file", {
                keyPath: "uuid",
            });
            if (oldVersion === 1) {
                // Migrate data
                const keyValStore = transaction.objectStore("keyval");
                const formStore = transaction.objectStore("form");
                const syncFileStore = transaction.objectStore("sync-file");
                let keyvalCursor = await keyValStore.openCursor();
                while (keyvalCursor) {
                    const item = keyvalCursor.value;
                    item.key = keyvalCursor.key;
                    if (item.key.startsWith("sync-image:")) {
                        const key = item.key;
                        delete item.key;
                        delete item.type;
                        item.uuid = key.split(":")[2];
                        syncFileStore.put(item);
                        keyValStore.delete(key);
                    }
                    else if (item.key.startsWith("form:")) {
                        const key = item.key;
                        delete item.key;
                        formStore.put(item, key.replace("form:", ""));
                        keyValStore.delete(key);
                    }
                    keyvalCursor = await keyvalCursor.continue();
                }
            }
            else {
                db.createObjectStore("keyval");
            }
        },
    });
}
export async function get(storeName, key) {
    return await operationWithLock(storeName, "get", key);
}
export async function getKey(storeName, key) {
    return await operationWithLock(storeName, "getKey", key);
}
export async function getAll(storeName, query, count) {
    return await operationWithLock(storeName, "getAll", query, count);
}
export async function getAllFromIndex(storeName, indexName) {
    return await operationWithLock(storeName, "getAllFromIndex", indexName);
}
export async function set(storeName, val, key) {
    return await operationWithLock(storeName, "put", val, key);
}
export async function del(storeName, key) {
    return await operationWithLock(storeName, "delete", key);
}
export async function keys(storeName, query, count) {
    return await operationWithLock(storeName, "getAllKeys", query, count);
}
// Utils
async function operationWithLock(storeName, op, ...args) {
    if (!navigator.locks) {
        return await operation(storeName, op, 1, ...args);
    }
    let value;
    await navigator.locks.request("db", async (lock) => {
        value = await operation(storeName, op, 1, ...args);
    });
    return value;
}
async function operation(storeName, op, tries, ...args) {
    try {
        return await (await openIDBWithLock())[op](storeName, ...args);
    }
    catch (e) {
        if (tries === 5)
            throw e;
        console.warn(`DB operation error: ${e} Retrying operation...`);
        dbHandler = null;
        return await operation(storeName, op, tries + 1, ...args);
    }
}
export async function openCursorWithLock(storeName, query) {
    if (!navigator.locks) {
        return await openCursor(storeName, query, 1);
    }
    let value;
    await navigator.locks.request("db", async (lock) => {
        value = await openCursor(storeName, query, 1);
    });
    return value;
}
async function openCursor(storeName, query, tries) {
    try {
        return (await openIDBWithLock())
            .transaction(storeName)
            .store.openCursor(query);
    }
    catch (e) {
        if (tries === 5)
            throw e;
        console.warn(`DB transaction error: ${e} Retrying transaction...`);
        dbHandler = null;
        return await openCursor(storeName, query, tries + 1);
    }
}
//# sourceMappingURL=idb.js.map